import { http } from '@/shared/api/http';

/**
 * Le jeton d'une session usurpée, et de quoi nommer la personne.
 *
 * L'adresse arrive avec le jeton pour que le bandeau puisse s'afficher avant le premier
 * appel à l'API : sans elle, l'interface dirait « session usurpée » sans dire de qui.
 */
export interface ImpersonationToken {
  accessToken: string;
  targetUserId: string;
  targetKeycloakId: string;
  targetEmail: string;
}

/**
 * Échange le code à usage unique contre le jeton.
 *
 * L'endpoint n'est pas authentifié, et c'est voulu : au moment de cet appel l'application
 * n'a aucune session — c'est précisément ce qu'elle vient chercher. Ce qui tient lieu de
 * preuve est le code, que le backend supprime en le lisant et périme en soixante secondes.
 */
export async function fetchImpersonationToken(
  code: string
): Promise<ImpersonationToken> {
  const { data } = await http.get<{ data: ImpersonationToken }>(
    '/impersonation/token',
    {
      params: { code }
    }
  );
  return data.data;
}
